import { useState, useEffect } from 'react';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import Styles from './mIndex.module.scss';

const reportReasonList = [{
  label: '广告垃圾',
  value: 'advertisement',
}, {
  label: '违规内容',
  value: 'illegal-content',
}, {
  label: '恶意灌水',
  value: 'bad-intention',
}, {
  label: '重复发帖',
  value: 'duplication',
}, {
  label: '其他',
  value: 'others',
}];

export interface ICommonDialog {
  className?: string;
  title: string;
  description?: string;
  reasonsList?: string[];
  isReport?: boolean;
  confirmText?: string;
  cancelText?: string;
  onConfirm: (reason: string, desc?: string) => void;
  onCancel: () => void;
}

const CommonDialog = ({
  className = '',
  title,
  description,
  reasonsList,
  isReport,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}: ICommonDialog) => {
  const [selectedReason, setSelectedReason] = useState<string>('');
  const [reasonDesc, setReasonDesc] = useState('');
  const t = useTranslations();

  useEffect(() => {
    return () => {
      setSelectedReason('');
      setReasonDesc('');
    };
  }, []);

  const handleSelectReason = (reason: string) => {
    setSelectedReason(reason);
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = e.target.value;
    setReasonDesc(val);
  };

  const handleSubmit = () => {
    if ((reasonsList?.length || isReport) && !selectedReason) {
      return;
    }
    onConfirm(selectedReason, reasonDesc);
  };

  return (
    <div className={cx(Styles.root, className)}>
      <div className={cx(Styles.contentWrapper, {[Styles.wideWrapper]: reasonsList?.length || isReport})}>
        <div className={Styles.title}>{title}</div>
        {description && <div className={Styles.description}>{description}</div>}
        {
          isReport ? (
            <div className={Styles.reasons}>
              {
                reportReasonList.map(({ label, value }: { label: string, value: string }) => (
                  <div
                    key={value}
                    className={cx(Styles.reason, { [Styles.selected]: selectedReason === label })}
                    onClick={() => handleSelectReason(label)}
                  >{label}</div>
                ))
              }
            </div>
          ) : (
            reasonsList && (
              <div className={Styles.reasons}>
                {
                  reasonsList.map((reason) => (
                    <div
                      key={reason}
                      className={cx(Styles.reason, { [Styles.selected]: selectedReason === reason })}
                      onClick={() => handleSelectReason(reason)}
                    >{reason}</div>
                  ))
                }
              </div>
            )
          )
        }
        {
          selectedReason === '其他' && (
            <textarea
              className={Styles.textarea}
              onChange={handleTextareaChange}
              value={reasonDesc}
              rows={3}
              maxLength={200}
              placeholder={t('tips_report_placeholder')}
              autoFocus
            />
          )
        }
        <div className={Styles.actions}>
          <div className={cx(Styles.cancel, Styles.action)} onClick={onCancel}>{cancelText || t('btn_cancel')}</div>
          <div className={cx(Styles.submit, Styles.action, {[Styles.noSelected]: (reasonsList?.length || isReport) && !selectedReason})} onClick={handleSubmit}>{confirmText || t('btn_confirm')}</div>
        </div>
      </div>
    </div>
  );
};

export default CommonDialog;
